module.exports = __webpack_public_path__ + "static/media/discover-hovered.7247dd7a.svg";